export function EnabledIcon({
  className = "size-5",
}: {
  className?: string;
}) {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
      <path d="M10 3V9.5M15.3 5.03335C16.3487 6.08234 17.0627 7.41872 17.3519 8.87351C17.6411 10.3283 17.4924 11.8362 16.9247 13.2065C16.357 14.5768 15.3957 15.748 14.1624 16.572C12.9291 17.396 11.4791 17.8358 9.99585 17.8358C8.5126 17.8358 7.06265 17.396 5.82933 16.572C4.59602 15.748 3.63472 14.5768 3.06699 13.2065C2.49926 11.8362 2.35059 10.3283 2.63978 8.87351C2.92897 7.41872 3.64304 6.08234 4.69169 5.03335" stroke="currentColor" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round" />
    </svg>
  );
}
export const displayName = "EnabledIcon";
